import {create} from 'zustand';

const useProductStore = create((set) => ({
    productList: [],
    replaceProducts: (data) => {
        set(() => ({
            productList: [...data]
        }))
    }
}))

export default useProductStore;